import { useLayoutEffect, useRef, useState, type CSSProperties } from 'react';
import { voiceGridLayout } from './voiceGridLayout';

export function useVoiceGridLayout(count: number, hasError: boolean, here: boolean) {
  const ref = useRef<HTMLDivElement>(null);
  const [layout, setLayout] = useState(() => voiceGridLayout(count, 0, 0));
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const error = element.querySelector<HTMLElement>('[data-voice-error]');
    const measure = () => {
      const css = getComputedStyle(element);
      const width = element.clientWidth - parseFloat(css.paddingLeft) - parseFloat(css.paddingRight);
      const height = element.clientHeight - parseFloat(css.paddingTop) - parseFloat(css.paddingBottom)
        - (error ? error.offsetHeight + parseFloat(css.rowGap || '0') : 0);
      const next = voiceGridLayout(count, width, height);
      setLayout(previous => previous.width === next.width && previous.height === next.height
        && previous.tileWidth === next.tileWidth ? previous : next);
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(element);
    if (error) observer?.observe(error);
    window.addEventListener('resize', measure);
    return () => { observer?.disconnect(); window.removeEventListener('resize', measure); };
  }, [count, hasError, here]);
  const style = {
    width: layout.width,
    height: layout.height,
    '--voice-tile-width': `${layout.tileWidth}px`,
    '--voice-tile-height': `${layout.tileHeight}px`,
  } as CSSProperties;
  return { ref, style };
}
